import {
    SHOW_SELECTOR,
    HIDE_SELECTOR,
    TOGGLE_SELECTOR,
    SET_MANAGE_PROFILES_TEXT,
} from './constants'

export function showSelector(userId, title, boundingRectangle) {
    return {
        type: SHOW_SELECTOR,
        payload: { userId, title, boundingRectangle },
    }
}

export function hideSelector() {
    return { type: HIDE_SELECTOR }
}

export function toggleSelector(userId, title, boundingRectangle) {
    return {
        type: TOGGLE_SELECTOR,
        payload: { userId, title, boundingRectangle },
    }
}

export function setManageProfilesText(text) {
    return {
        type: SET_MANAGE_PROFILES_TEXT,
        payload: text,
    }
}



// WEBPACK FOOTER //
// ./src/features/ProfileSelector/data/actions.js